import React, { Component } from "react";
import { Navigate } from 'react-router-dom'
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { Select, Typography, Mentions } from "antd";
import * as liveScheduleActions from '../../redux/actions/liveScheduleActions.js';

const { Text } = Typography;
const { Option } = Select;

class LiveSchedulesToggle extends Component {

  constructor(props) {
    super(props);

    this.state = {
      schedule: '',
      startDate: '',
      scheduleFormat: this.props.scheduleFormat || (this.props.liveScheduleParameters && this.props.liveScheduleParameters.scheduleFormat) || '',
      resourceName: '',
      resourceId: 0,
      toggleValueChange: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scheduleFormat !== this.props.scheduleFormat && this.props.scheduleFormat && !this.state.toggleValueChange) {
      this.setState({ scheduleFormat: this.props.scheduleFormat });
    }
  }

  handleChange = async (value) => {
    let localStorageState = this.props.liveScheduleParameters;
    const { startDate, resourceCollectionName, resourceCollectionId } = localStorageState;

    if (value && value !== this.state.scheduleFormat) {
      let redirect;
      (value == 1 || value == 2) && (this.state.scheduleFormat == 7 || this.state.scheduleFormat == 9) ? redirect = true :
        (value == 7 || value == 9) && (this.state.scheduleFormat == 1 || this.state.scheduleFormat == 2) ? redirect = true : redirect = false;

      await this.props.actions.updateLiveScheduleParameters({startDate, scheduleFormat: value, resourceCollectionName, resourceCollectionId});

      this.setState({
        startDate,
        scheduleFormat: value,
        resourceCollectionName,
        resourceCollectionId,
        toggleValueChange: true
      }, () => {
        this.props.onToggleChange(
          {
            redirect,
            scheduleFormat: value
          });
      });
    } else {
      //error handling
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select value={this.state.scheduleFormat} style={{ width: 110, marginBottom: 20 }} onChange={this.handleChange}
         options ={[{value: 1, label:"1-day"},{value: 2, label:"2-day"},{value: 7, label:"7-day"},{value: 9, label:"9-day"}]}
        >
         
        </Select>
        {this.state.toggleValueChange && (
          <Navigate
            to={(this.state.scheduleFormat === 1 || this.state.scheduleFormat === 2) ? '/live-schedule-view-short' : '/live-schedule-view-long'}
            state={{
              startDate: this.state.startDate,
              scheduleFormat: this.state.scheduleFormat,
              resourceCollectionName: this.state.resourceCollectionName,
              resourceCollectionId: this.state.resourceCollectionId
            }}
          />
        )}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    liveScheduleParameters: state.liveScheduleParameters
    // listPostedSchedules: state.listPostedSchedules
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      updateLiveScheduleParameters: bindActionCreators(
        liveScheduleActions.updateLiveScheduleParameters,
        dispatch
      )
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveSchedulesToggle)
